var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Header } from '../util/headers';
export class AxiosStorage {
    constructor() {
        this.get = (key) => __awaiter(this, void 0, void 0, function* () {
            const value = yield this.find(key);
            if (value.state !== 'cached' ||
                // Cached and fresh value
                value.createdAt + value.ttl > Date.now()) {
                return value;
            }
            // Check if his can stale value.
            if (AxiosStorage.keepIfStale(value)) {
                const stale = {
                    data: value.data,
                    state: 'stale',
                    createdAt: value.createdAt
                };
                yield this.set(key, stale);
                return stale;
            }
            yield this.remove(key);
            return { state: 'empty' };
        });
    }
}
/** Returns true if a invalid cache should still be kept */
AxiosStorage.keepIfStale = ({ data }) => {
    if (data === null || data === void 0 ? void 0 : data.headers) {
        return (Header.ETag in data.headers ||
            Header.LastModified in data.headers ||
            Header.XAxiosCacheEtag in data.headers ||
            Header.XAxiosCacheLastModified in data.headers);
    }
    return false;
};
